<template>
  <div class="family" v-title data-title="广东多对多物联集团股份有限公司">
    <div class="mar_top"></div>

    <div class="head_title">
      <p class="p1">
        多对多数字家庭&nbsp;&nbsp;健康
        <span class="spot_1">.</span>
        平安
        <span class="spot_1">.</span>
        便捷
        <span class="spot_1">.</span>
        有趣
      </p>
      <p class="line"></p>
    </div>

    <div class="number_healthy_min_title">
      <p>
        多对多物联集团为社区提供数字化增值服务。以社区为中心，以家庭为单位，将居民的生活
        ，健康，安全以及居家养老需求与社区的党政服务，健康服务，养老服务，本地商业，通过多对多
        数字化体系连接到一起，形成一体化，一站式的全天候全龄段解决方案，满足家庭高品质生活新刚需。
      </p>
      <div class="imgBox">
        <img src="~img/family/familyImg.png" alt="" />
      </div>
    </div>

    <div class="top_shadow">
      <div class="voice_robot">
        <div class="voice_robot_div1">
          <img src="~img/family/duoduoBg.png" alt="" />
        </div>
        <div class="voice_robot_div2">
          <div class="div1"></div>
          <div class="div2">
            <p>幸福<br />指数</p>
          </div>
          <div class="div1"></div>
          <div class="div2">
            <p>美好<br />生活</p>
          </div>
          <div class="div1"></div>
          <div class="div2">
            <p>安全<br />有趣</p>
          </div>
          <div class="div1"></div>
        </div>
        <div class="voice_robot_div3">
          <h3>独家研发语音中控机器人“多对多智慧管家机器人”</h3>
          <div class="line"></div>
          <p>控制全屋智能产品，跨品牌，跨品类，物联无壁垒。</p>
          <p>在家语音，释放双手；在外APP，远程安全。</p>
          <p>2018年12月获得粤港物联网大赛“最佳物联网创意奖”。</p>
          <p>连接智能小区-连接智慧社区-连接周边商业。</p>
          <img src="~img/neighbourhood/img55.png" alt="" />
        </div>
      </div>
    </div>
    <div class="duoduo_family_tabBar">
      <div class="duoduo_tabbar_flex">
        <div
          v-for="(item, index) in tabArr"
          :key="index"
          @click="tabClick(index)"
          :class="tabIndex == index ? 'tabbar_btn activeBtn' : 'tabbar_btn'"
        >
          {{ item }}
        </div>
      </div>
    </div>

    <!-- 健康 -->
    <div v-if="tabIndex == 0">
      <div class="head_title">
        <p class="p1">数字健康解决方案</p>
        <p class="line"></p>
        <p class="p3">
          多对多从家庭健康出发，联动小区，社区及健康管理服务机构<br />基于物联网应用技术，实现健康可视化实时动态管理
        </p>
      </div>

      <div class="health_management">
        <div class="head_linear_grad head_linear_grad_width">全家健康管理</div>

        <div class="health_tab_img">
          <img src="~img/neighbourhood/group3.png" alt="" />
        </div>

        <div class="health_tab_word">
          <div>
            <p>儿童<br />健康</p>
          </div>
          <div>
            <p>女性<br />健康</p>
          </div>
          <div>
            <p>男性<br />健康</p>
          </div>
          <div>
            <p>中老年人<br />健康</p>
          </div>
        </div>
      </div>

      <div class="img_array_1">
        <ul>
          <li>
            <img src="~img/neighbourhood/img1.png" alt="" />
            <p>肠道微生态营养干预</p>
          </li>
          <li>
            <img src="~img/neighbourhood/img2.png" alt="" />
            <p>高血压营养干预</p>
          </li>
          <li>
            <img src="~img/neighbourhood/img3.png" alt="" />
            <p>精准体重管理</p>
          </li>
          <li>
            <img src="~img/neighbourhood/img4.png" alt="" />
            <p>儿童营养健康管理</p>
          </li>
          <li>
            <img src="~img/neighbourhood/img5.png" alt="" />
            <p>代谢综合症营养干预</p>
          </li>
          <li>
            <img src="~img/neighbourhood/img6.png" alt="" />
            <p>睡眠健康管理</p>
          </li>
          <li>
            <img src="~img/neighbourhood/img7.png" alt="" />
            <p>抗衰老管理</p>
          </li>
          <li class="li_end">
            <img src="~img/neighbourhood/img8.png" alt="" />
            <p>骨营养干预</p>
          </li>
        </ul>
      </div>

      <!-- <div class="img_array_2">
				<ul>
					<li>
						<img src="~img/neighbourhood/img9.png" alt="" >
						<h3>数字家庭</h3>
						<p>解决家人日常健康管理难，实现家人随时关怀。</p>
					</li>
					<li>
						<img src="~img/neighbourhood/img10.png" alt="" >
						<h3>数字康养</h3>
						<p>解决康养中心联接家庭难，实现实时在线，价值持续。</p>
					</li>
					<li class="li_end">
						<img src="~img/neighbourhood/img11.png" alt="" >
						<h3>数字健康社区</h3>
						<p>解决数字社区健康中心运营难，实现社区与小区，家庭全联动。</p>
					</li>
				</ul>
			</div> -->

      <!-- <div class="img_array_3">
				<ul>
					<li>
						<img src="~img/neighbourhood/img12.png" alt="" >
						<h3>居家养老</h3>
						<p>联接家人，信息同步；联接康养中心，健康护理上门服务；慢性病管理服务更专业；小多救命；跌倒呼援更安全
						；电视语音购物，物业代购取件；小区朋友圈畅聊无阻，实时在线欢乐多。</p>
					</li>
					<li>
						<img src="~img/neighbourhood/img13.png" alt="" >
						<h3>数字健康城</h3>
						<p>携手国药集团国健健康城，中国移动，中国联通，中国人保健康广东公司，中科微量元素研究院，华南农业大学，同江
						医院，和平医院等大健康合作伙伴赋能全国各地健康主题地产产业可持续发展。</p>
					</li>
				</ul>
			</div> -->

      <div class="serve_record">
        <div class="head_linear_grad head_linear_grad_width">
          家人可查询管理服务记录
        </div>

        <div class="img_array_4">
          <ul>
            <li>
              <img src="~img/neighbourhood/img14.png" alt="" />
              <p>私人健康顾问</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img15.png" alt="" />
              <p>健康指导</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img16.png" alt="" />
              <p>联动亲人</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img17.png" alt="" />
              <p>视频通话</p>
            </li>
            <li class="li_end">
              <img src="~img/neighbourhood/img18.png" alt="" />
              <p>预警设置</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="health_consultant">
        <div class="head_linear_grad head_linear_grad_width">健康顾问服务</div>

        <div class="img_array_4">
          <ul>
            <li>
              <img src="~img/neighbourhood/img19.png" alt="" />
              <p>私人健康数据库</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img20.png" alt="" />
              <p>健康预警</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img21.png" alt="" />
              <p>紧急呼援</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img22.png" alt="" />
              <p>视频指导</p>
            </li>
            <li class="li_end">
              <img src="~img/neighbourhood/img23.png" alt="" />
              <p>签约管理</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 平安 -->
    <div v-if="tabIndex == 1">
      <div class="head_title">
        <p class="p1">数字平安解决方案</p>
        <p class="line"></p>
        <p class="p3">
          多对多以守护家庭为己任，<span class="span_color"
            >可联动数字小区，实现24小时在线安全监控与预警。</span
          ><br />
          数字家庭，数字公寓，数字厨房等应用场景，解决陌生人入侵只能识别，漏水，漏气，烟雾火焰智能监测及预警，实现快速呼援。
        </p>
      </div>

      <div class="img_array_5">
        <ul>
          <li>
            <img src="~img/neighbourhood/img24.png" alt="" />
          </li>
          <li>
            <img src="~img/neighbourhood/img25.png" alt="" />
          </li>
          <li>
            <img src="~img/neighbourhood/img26.png" alt="" />
          </li>
          <li>
            <img src="~img/neighbourhood/img27.png" alt="" />
          </li>
        </ul>
      </div>

      <div class="health_management">
        <div class="head_linear_grad head_linear_grad_width_2">
          守护家庭财产安全
        </div>

        <div class="health_tab_img">
          <img src="~img/neighbourhood/group3.png" alt="" />
        </div>

        <div class="health_tab_word">
          <div>
            <p>智能<br />门锁</p>
          </div>
          <div>
            <p>入侵<br />报警</p>
          </div>
          <div>
            <p>离家<br />设防</p>
          </div>
          <div>
            <p>24小时<br />在线监控</p>
          </div>
        </div>
      </div>

      <div class="support_1"></div>

      <div class="health_consultant">
        <div class="head_linear_grad head_linear_grad_width_3">
          保障居家人身安全
        </div>

        <div class="img_array_4">
          <ul>
            <li>
              <img src="~img/neighbourhood/img28.png" alt="" />
              <p>漏水预警</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img29.png" alt="" />
              <p>小多救命</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img30.png" alt="" />
              <p>烟雾预警</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img31.png" alt="" />
              <p>漏气预警</p>
            </li>
            <li class="li_end">
              <img src="~img/neighbourhood/img32.png" alt="" />
              <p>一键呼援</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="Joint_prevention_and_control">
        <div class="head_linear_grad head_linear_grad_width_3">
          安全多方联防联控
        </div>

        <div class="support_1"></div>

        <div class="img_array_6">
          <ul>
            <!-- <li>
							<img src="~img/neighbourhood/img33.png" alt="" >
							<p>远程监控</p>
						</li> -->
            <li>
              <img src="~img/neighbourhood/img34.png" alt="" />
              <p>智能处理</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img35.png" alt="" />
              <p>通知物业</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img36.png" alt="" />
              <p>授权处理</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img37.png" alt="" />
              <p>通知家人</p>
            </li>
            <li class="li_end">
              <img src="~img/neighbourhood/img38.png" alt="" />
              <p>联动机构</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 有趣 -->
    <div v-if="tabIndex == 2">
      <div class="head_title">
        <p class="p1">数字有趣解决方案</p>
        <p class="line"></p>
        <p class="p3">
          多对多创新多屏互动方式，跨品类，跨品牌，跨产品智联全屋，多场景随时定制，全年龄段用户都喜欢<br />
          适用于数字家庭，数字公寓，数字酒店，数字办公室等应用场景，解决不同品牌不同产品不能互联互动，多个APP操作，过于依赖手机等难题<br />
          实现与数字小区，社区及商业的联动
        </p>
      </div>

      <div class="Interesting_programme">
        <div class="one_phone">
          <div class="one_phone_word">
            <h3>一台电视一台手机<br />同一个APP轻松搞定</h3>
            <div class="one_phone_word_2">
              <p>
                操作简单，简易上手，方便快捷，<br />给你一个全新的智能体验！
              </p>
            </div>
            <div class="one_phone_word_3">
              <p>
                家庭共享健康数据，智能分析<br />家人健康情况，关爱家人每分每秒。
              </p>
            </div>
          </div>
        </div>
        <div class="img_array_7">
          <img src="~img/neighbourhood/img40.png" alt="" />
          <img src="~img/neighbourhood/img41.png" alt="" />
          <img src="~img/neighbourhood/img42.png" alt="" />
        </div>
      </div>

      <div class="health_management">
        <div class="head_linear_grad head_linear_grad_width_4">交流互动</div>

        <div class="health_tab_img">
          <img src="~img/neighbourhood/group3.png" alt="" />
        </div>

        <div class="health_tab_word">
          <div>
            <p>大屏<br />视频</p>
          </div>
          <div>
            <p>画面<br />亲切</p>
          </div>
          <div>
            <p>视频<br />通话</p>
          </div>
          <div>
            <p>手机电视<br />可联动</p>
          </div>
        </div>
      </div>

      <div class="serve_recreation">
        <div class="head_linear_grad head_linear_grad_width_4">服务与娱乐</div>
        <div class="img_array_8">
          <ul>
            <li>
              <img src="~img/neighbourhood/img43.png" alt="" />
              <p>辅导服务</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img44.png" alt="" />
              <p>家政服务</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img45.png" alt="" />
              <p>健康服务</p>
            </li>
            <li class="li_end">
              <img src="~img/neighbourhood/img46.png" alt="" />
              <p>小区服务</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img47.png" alt="" />
              <p>社区服务</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img48.png" alt="" />
              <p>周边服务</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img49.png" alt="" />
              <p>海量音乐</p>
            </li>
            <li class="li_end">
              <img src="~img/neighbourhood/img50.png" alt="" />
              <p>视频点播</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img51.png" alt="" />
              <p>在线KTV</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img52.png" alt="" />
              <p>电视直播</p>
            </li>
            <li>
              <img src="~img/neighbourhood/img53.png" alt="" />
              <p>生活资讯</p>
            </li>
            <li class="li_end">
              <img src="~img/neighbourhood/img54.png" alt="" />
              <p>在线翻译</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="duoduoIntro container-fluid">
      <div class="container">
        <div class="item row">
          <div class="left col-sm-6">
            <div class="lfBox">
              <h3>一个系统满足<br />多品牌多产品物联</h3>
              <p class="btText_p">避免不同品牌产品无法物联的尴尬！</p>
              <p class="btText btText_p">
                多对多物联平台已吸引400多个知名专业品牌入驻，<br />联接智能产品数超2000款。
              </p>
            </div>
          </div>
          <div class="right col-sm-6">
            <ul>
              <li>照明设备</li>
              <li>红外设备</li>
              <li>电机设备</li>
              <li>能源设备</li>
              <li>健康设备</li>
              <li>睡眠设备</li>
              <li>安防设备</li>
              <li>环境设备</li>
              <li>智能卫浴</li>
              <li>智能家电</li>
              <li>智能家具</li>
              <li>智能门锁</li>
            </ul>
          </div>
        </div>
        <div class="item center row">
          <div class="left col-sm-6">
            <div class="lfBox">
              <h3>一个系统满足<br />多功能应用交互</h3>
              <p class="btText_p">避免多个系统孤岛给生活造成的不便及烦恼！</p>
            </div>
          </div>
          <div class="right col-sm-6">
            <ul>
              <li>
                <div class="title">照明设备</div>
                <div class="text">
                  App&语音<br />
                  一键控制<br />
                  智能互联<br />
                </div>
              </li>
              <li>
                <div class="title">数字用电</div>
                <div class="text">
                  统计<br />
                  安全<br />
                  控制<br />
                </div>
              </li>
              <li>
                <div class="title">数字健康</div>
                <div class="text">
                  健康知识<br />
                  识别食物&运动<br />
                  检测&数据<br />
                </div>
              </li>
              <li>
                <div class="title">数字睡眠</div>
                <div class="text">
                  睡眠监测<br />
                  睡眠报告<br />
                </div>
              </li>
              <li>
                <div class="title">智能安防</div>
                <div class="text">
                  传感<br />
                  报警<br />
                  通知<br />
                </div>
              </li>
              <li>
                <div class="title">环境管理</div>
                <div class="text">
                  数据采集<br />
                  算法<br />
                  实时数据<br />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="item row">
          <div class="left col-sm-6">
            <div class="lfBox">
              <h3>一个系统满足<br />多元化服务</h3>
              <p class="btText_p">为您及家人的生活创造更多便利与幸福！</p>
            </div>
          </div>
          <div class="right col-sm-6">
            <ul>
              <li>视频通话</li>
              <li>公共监控</li>
              <li>数字共享</li>
              <li>数字物业</li>
              <li>数字书屋</li>
              <li>智能预约</li>
              <li>社区服务</li>
              <li>数字健康</li>
              <li>周边购物</li>
              <li>周边服务</li>
              <li>你能想到的</li>
              <li>意想不到的</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "family",
  data() {
    return {
      tabArr: ["数字健康解决方案", "数字平安解决方案", "数字有趣解决方案"], // 切换tab
      tabIndex: 0, // tab 高亮
    };
  },
  methods: {
    // tab点击
    tabClick(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style scoped lang="less">
.bottom {
  box-shadow: none !important;
}

// 公共css --- start
.head_title {
  text-align: center;
  .p1 {
    font-size: 28px;
    color: #000;
    font-weight: bold;
    .vertical {
      background-color: #000;
      width: 2px;
      height: 18px;
      display: inline-block;
      position: relative;
      top: 3px;
    }
    .spot_1 {
      position: relative;
      top: -5px;
    }
  }
  .line {
    width: 40px;
    height: 2px;
    margin: 20px auto 0;
    background: #ee7b1d;
  }
  .p3 {
    margin-top: 16px;
    font-size: 18px;
    color: #7c7a7a;

    .min_spot {
      font-size: 12px;
      margin: 0 2px;
      position: relative;
      top: -3px;
      color: #7c7a7a;
    }
    .span_color {
      color: #ee7b1d;
    }
  }
}

.border_shadow {
  box-shadow: 0 0 10px 2px #ffeeee;
}

.top_shadow {
  box-shadow: 0 -10px 10px -3px #ffeeee;
}

.line {
  height: 2px;
  width: 50px;
  background: #ee7b1d;
  margin: 20px auto;
}

.spot_con {
  position: relative;
  top: -3px;
  color: #4b4746;
  font-size: 18px;
}

.head_linear_grad {
  margin: 0 auto;
  text-align: center;
  line-height: 50px;
  height: 50px;
  background: linear-gradient(to right, #ee7b1d, #ffaa51);
  border-radius: 8px;
  font-size: 24px;
  color: #fff;
  letter-spacing: 6px;
}

.head_linear_grad_width_3 {
  width: 290px;
}

.head_linear_grad_width_4 {
  width: 200px;
}

.support_1 {
  height: 50px;
}

// 公共css --- end

.mar_top {
  height: 50px;
}

.number_healthy_min_title {
  width: 920px;
  margin: 20px auto;
  @media (max-width: 576px) {
    width: 98%;
  }

  p {
    font-size: 16px;
    color: #6e6d46;
    line-height: 34px;
    text-align: center;
  }
  .imgBox {
    margin: 20px auto 0;
    width: 1110px;
    height: 340px;
    @media (max-width: 576px) {
      width: 98%;
      height: 200px;
    }
    img {
      width: 1110px;
      height: 340px;
      background-size: 100% 100%;
      @media (max-width: 576px) {
        width: 98%;
        height: 200px;
      }
    }
  }
}

.voice_robot {
  margin: 30px auto 0;
  display: flex;
  width: 1200px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  @media (max-width: 576px) {
    width: 100%;
  }

  .voice_robot_div1 {
    padding-top: 50px;
    img {
      width: 463px;
      height: 567px;
      background-size: 100% 100%;
      @media (max-width: 576px) {
        width: 100%;
        height: 400px;
      }
    }
  }
  .voice_robot_div2 {
    width: 245px;
    @media (max-width: 576px) {
      display: none;
    }
    .div1 {
      width: 2px;
      height: 100px;
      box-shadow: 0 0 10px 2px #ffeeee;
      margin: 0 auto;
      background-color: #ffeeee;
    }
    .div2 {
      background-image: url("../../assets/images/trade/znkzbg.png");
      background-size: 100% 100%;
      width: 110px;
      height: 115px;
      margin: 0 auto;
      text-align: center;
      p {
        font-size: 18px;
        color: #ee8835;
        padding-top: 30px;
      }
    }
  }
  .voice_robot_div3 {
    width: 490px;
    padding-top: 90px;
    @media (max-width: 576px) {
      width: 98%;
      padding-top: 40px;
    }
    h3 {
      font-size: 25px;
      color: #000;
      // font-weight: bold;
    }
    .line {
      width: 40px;
      height: 2px;
      margin: 20px 0 40px;
      background: #ee7b1d;
    }
    p {
      font-size: 18px;
      color: #374531;
      margin-bottom: 30px;
      @media (max-width: 576px) {
        margin-bottom: 20px;
      }
    }
    img {
      margin-top: 50px;
      @media (max-width: 576px) {
        width: 98%;
        margin-top: 20px;
      }
    }
  }
}

.duoduo_family_tabBar {
  height: 110px;
  width: 100%;
  background: #ee7b1d;
  margin-bottom: 40px;
  @media (max-width: 576px) {
    margin-top: 20px;
    height: 80px;
  }
  .duoduo_tabbar_flex {
    width: 66.6%;
    @media (max-width: 576px) {
      width: 100%;
    }
    display: flex;
    margin: 0 auto;
    .tabbar_btn {
      width: 320px;
      height: 110px;
      text-align: center;
      font-weight: 300;
      font-size: 28px;
      line-height: 110px;
      color: #fff;
      @media (max-width: 576px) {
        width: 33.3%;
        height: 80px;
        font-size: 15px;
        line-height: 80px;
        overflow: hidden;
      }
    }
    .tabbar_btn:hover {
      cursor: pointer;
    }
    .activeBtn {
      background: #fff;
      color: #ee7b1d !important;
    }
  }
}

.health_management {
  margin: 50px auto 0;
  width: 1200px;
  @media (max-width: 576px) {
    width: 100%;
  }
  .head_linear_grad_width {
    width: 250px;
  }

  .head_linear_grad_width_2 {
    width: 290px;
  }

  .health_tab_img {
    margin: 4px auto 0;
    display: flex;
    justify-content: center;
    img {
      width: 995px;
      height: 54px;
      background-size: 100% 100%;
      @media (max-width: 576px) {
        width: 78%;
      }
    }
  }

  .health_tab_word {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 1100px;
    margin: 0 auto;
    @media (max-width: 576px) {
      width: 100%;
    }
    div {
      background-image: url("../../assets/images/trade/znkzbg.png");
      background-size: 100% 100%;
      width: 100px;
      height: 105px;
      text-align: center;
      @media (max-width: 576px) {
        width: 25%;
      }
      p {
        font-size: 16px;
        color: #ee8835;
        padding-top: 28px;
        margin: 0;
      }
    }
    div:hover {
      background-image: url("../../assets/images/about/backactive.png");
      cursor: pointer;
      p {
        color: #fff;
      }
    }
  }
}

.duoduo {
  margin-top: 30px;
  padding: 50px 0;
  .duoduoBox {
    @media (max-width: 992px) {
      max-width: 850px;
    }

    .left {
    }

    .right {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px 0;

      @media (max-width: 400px) {
        padding: 0 16px;
      }
    }

    .textCont {
      .title {
        @media (min-width: 768px) {
          font-size: 22px;
        }

        @media (max-width: 768px) {
          font-size: 18px;
          line-height: 30px;
        }
      }

      .line {
        width: 40px;
        height: 2px;
        margin: 20px 0;
        background: #ee7b1d;
      }

      ul {
        li {
          padding-bottom: 24px;

          @media (max-width: 768px) {
            padding-bottom: 12px;
            font-size: 0.9rem;
          }
        }
      }
    }
  }
}

.img_array_1 {
  width: 1200px;
  margin: 30px auto 0;
  @media (max-width: 576px) {
    width: 98%;
  }
  ul {
    width: 1200px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    @media (max-width: 576px) {
      width: 98%;
      justify-content: space-around;
    }
    li {
      margin: 0 5px 20px 0;
      width: 145px;
      height: 118px;
      img {
        width: 145px;
        height: 84px;
        background-size: 100% 100%;
      }
      p {
        background-color: #eee;
        height: 34px;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        color: #706f72;
      }
    }
    .li_end {
      margin-right: 0;
    }
  }
}

.img_array_2 {
  margin: 10px auto 0;
  width: 1200px;
  @media (max-width: 576px) {
    width: 98%;
  }
  ul {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    li {
      width: 393px;
      margin: 0 10px 20px 0;
      background-color: #ffeeef;
      @media (max-width: 576px) {
        width: 100%;
        margin: 0 0 20px 0;
      }
      img {
        height: 234px;
        width: 393px;
        background-size: 100% 100%;
        @media (max-width: 576px) {
          width: 100%;
        }
      }
      h3 {
        font-size: 22px;
        color: #ee8835;
        font-weight: bold;
        padding: 20px 20px 0;
      }
      p {
        font-size: 16px;
        color: #706f72;
        line-height: 22px;
        padding: 10px 20px;
      }
    }
    .li_end {
      margin-right: 0;
    }
  }
}

.img_array_3 {
  margin: 10px auto 0;
  width: 1200px;
  @media (max-width: 576px) {
    width: 98%;
  }
  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      width: 590px;
      margin: 0 10px 20px 0;
      background-color: #ffeeef;
      @media (max-width: 576px) {
        width: 100%;
        margin: 0 0 20px 0;
      }
      img {
        height: 348px;
        width: 590px;
        background-size: 100% 100%;
        @media (max-width: 576px) {
          width: 100%;
          height: 370px;
        }
      }
      h3 {
        font-size: 22px;
        color: #ee8835;
        font-weight: bold;
        padding: 20px 20px 0;
      }
      p {
        font-size: 16px;
        color: #706f72;
        line-height: 22px;
        padding: 10px 20px;
      }
    }
  }
}

.serve_record {
  margin: 50px auto 0;
  width: 1200px;
  @media (max-width: 576px) {
    width: 100%;
  }
  .head_linear_grad_width {
    width: 370px;
    @media (max-width: 576px) {
      width: 96%;
    }
  }
}

.img_array_4 {
  margin: 30px auto 0;
  width: 1200px;
  @media (max-width: 576px) {
    width: 100%;
  }
  ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    @media (max-width: 576px) {
      justify-content: space-around;
    }
    li {
      width: 232px;
      margin: 0 10px 20px 0;
      @media (max-width: 576px) {
        width: 48%;
        margin: 0 0 20px 0;
      }
      img {
        height: 160px;
        width: 232px;
        background-size: 100% 100%;
        @media (max-width: 576px) {
          width: 100%;
        }
      }
      p {
        font-size: 20px;
        color: #706f72;
        line-height: 34px;
        text-align: center;
        background-color: #eee;
      }
    }
    .li_end {
      margin-right: 0;
    }
  }
}

.health_consultant {
  margin: 30px auto 70px;
  width: 1200px;
  @media (max-width: 576px) {
    width: 100%;
  }
  .head_linear_grad_width {
    width: 210px;
  }
}

.img_array_5 {
  width: 100%;
  margin: 50px 0;
  ul {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    li {
      width: 25%;
      margin-bottom: 20px;
      img {
        height: 338px;
        width: 100%;
        background-size: 100% 100%;
        @media (max-width: 576px) {
          height: 100px;
        }
      }
    }
  }
}

.Joint_prevention_and_control {
  margin: 40px auto 100px;
  width: 1200px;
  @media (max-width: 576px) {
    width: 100%;
    margin: 40px auto 60px;
  }
  .img_array_6 {
    ul {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      @media (max-width: 576px) {
        justify-content: space-around;
      }
      li {
        width: 232px;
        margin: 0 10px 10px 0;
        @media (max-width: 576px) {
          width: 48%;
          margin: 0 0 10px 0;
        }
        img {
          width: 232px;
          height: 160px;
          background-size: 100% 100%;
          @media (max-width: 576px) {
            width: 100%;
            height: 160px;
          }
        }
        p {
          margin-top: 2px;
          background-color: #ffeef0;
          font-size: 20px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          color: #ee8835;
        }
      }
      .li_end {
        margin-right: 0;
      }
    }
  }
}

.Interesting_programme {
  width: 100%;
  margin: 30px 0;
  .one_phone {
    background-image: url(../../assets/images/neighbourhood/img39.png);
    background-size: 100% 100%;
    width: 100%;
    height: 600px;
    @media (max-width: 576px) {
      height: 300px;
    }
    .one_phone_word {
      padding: 100px 0 0 300px;
      @media (max-width: 576px) {
        padding: 20px 0 0 40px;
      }
      p {
        margin: 0;
        padding: 0;
      }
      h3 {
        font-size: 26px;
        color: #ee8835;
        line-height: 42px;
      }
      .one_phone_word_2 {
        font-size: 18px;
        color: #333;
        margin-top: 30px;
        line-height: 32px;
        @media (max-width: 576px) {
          margin-top: 10px;
        }
      }
      .one_phone_word_3 {
        background-color: #ee7b1d;
        border-radius: 8px;
        margin-top: 30px;
        padding: 20px 20px 30px;
        width: 340px;
        line-height: 32px;
        @media (max-width: 576px) {
          margin-top: 10px;
          width: 96%;
          padding: 10px 16px 10px;
        }
        p {
          font-size: 18px;
          color: #fff;
        }
      }
    }
  }
  .img_array_7 {
    display: flex;
    justify-content: flex-start;
    img {
      width: 33.3%;
      height: 340px;
      background-size: 100% 100%;
      @media (max-width: 576px) {
        height: 140px;
      }
    }
  }
}

.serve_recreation {
  width: 1200px;
  margin: 70px auto 50px;
  @media (max-width: 576px) {
    width: 100%;
    margin: 40px auto 30px;
  }
  .img_array_8 {
    margin-top: 30px;
    ul {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      @media (max-width: 576px) {
        justify-content: space-around;
      }
      li {
        width: 294px;
        margin: 0 8px 10px 0;
        @media (max-width: 576px) {
          width: 48%;
          margin: 0 0 10px 0;
        }
        img {
          width: 294px;
          height: 170px;
          background-size: 100% 100%;
          @media (max-width: 576px) {
            width: 100%;
          }
        }
        p {
          margin: 3px 0 0 0;
          background-color: #ffffee;
          font-size: 20px;
          color: #4e4c4b;
          line-height: 50px;
          text-align: center;
        }
      }
      .li_end {
        margin-right: 0;
      }
    }
  }
}

.family {
  .duoduoIntro {
    h3 {
      font-weight: bold;
      line-height: 52px;
    }

    background: linear-gradient(left, #ee7b1d, #f6af5a);
    padding-top: 80px;

    @media (max-width: 576px) {
      padding-top: 40px;
    }

    .item {
      color: #fff;
      padding-bottom: 80px;
      display: flex;
      justify-content: space-between;

      .left {
        padding-top: 20px;
        display: flex;
        // align-items: center;

        h3 {
          font-size: 40px;
          font-weight: 300;
        }
        h2 {
          line-height: 50px;
          padding-bottom: 20px;
        }
        .btText_p {
          font-size: 20px;
        }
        .btText {
          padding-top: 40px;
        }
      }

      .right {
        padding-top: 20px;

        ul {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          li {
            font-size: 18px;
            width: 22%;
            line-height: 80px;
            color: #ee7b1d;
            background: #ffffff;
            text-align: center;
            margin-bottom: 14px;
            border-radius: 5px;

            @media (max-width: 992px) {
              width: 30%;
            }

            @media (max-width: 768px) {
              width: 40%;
            }

            &:hover {
              background: #ee7b1d;
              color: #fff;

              .text {
                color: #fff;
              }
            }
          }
        }
      }

      &.center {
        ul {
          li {
            width: 30%;

            @media (max-width: 992px) {
              width: 46%;
            }

            line-height: 35px;
            padding: 10px 0;

            .title {
              font-size: 20px;
              margin: 0;
            }

            .text {
              color: #333;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

.rightCont_img {
}

@media (max-width: 992px) {
  .duoduo_tabbar_flex {
    width: 100% !important;
  }

  .rightCont_img {
    width: 100%;
  }
}

.line {
  height: 2px;
  width: 50px;
  background: #f1954a;
  margin: 20px auto;
}

.titBt {
  text-align: center;
  font-size: 14px;
  color: #8d8e90;
  margin: 0 auto;
  padding: 0 4% 5% 4%;
  line-height: 24px;
}

.title {
  text-align: center;
  margin-top: 60px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/pages/neighbourhood/neighbourhood.vue